import React from 'react'

function ShimmerSingleBox(props) {
  //console.log(props.CustomStyle);
  return (
    
      <div className="col col3">
        <div className="cat-wrap">
          <div className="cat-img shimmerBG" style={{height:props.CustomStyle.height}}></div>      
        </div>
      </div>
    
  )
}

export default ShimmerSingleBox
